import { get, flatten } from 'lodash'
import { toTimeObject } from '@/utils/time'

/**
 * Objectに id を追加して返却します
 * id は存在しなければindex番号を付与
 * @param {object} data
 * @returns {object}
 */
export function addId(data) {
  return data?.map((value, index) => {
    return { ...value, id: value.id || index }
  })
}

/**
 * Objectに isShow を追加して返却します
 * @param {object} data
 * @returns {object}
 */
export function initStatus(data) {
  return data?.map(value => {
    return { ...value, isShow: true }
  })
}

/**
 * isShowでfilterしたチャートデータを返却
 * @param {object} data
 * @param {object} headerAggregatedValue
 * @param {Array} target
 * @returns {Array}
 */

export function filterByIsShow(data, headerAggregatedValue, target) {
  /**
   * header
   * ['', value[0].name, value[1].name, ...]
   */
  const header = data
    .map(value => {
      return value.isShow ? value.name : null
    })
    .filter(v => v)
  /**
   * body
   * [
   *  [term1, value[0], value[1], ...]
   *  [term2, value[0], value[1], ...]
   *  ...
   * ]
   */
  const body = headerAggregatedValue.map((term, index) => {
    const qty = data
      .map(v => {
        return v.isShow ? get(v.aggregatedValue[index], target) : null
      })
      .filter(v => v !== null)
    return [term, ...qty]
  })
  return [['', ...header], ...body]
}

/**
 * 対象のIDと合致するデータのisShowを反転して返却
 * @param {object} data
 * @param {Number} id
 * @returns {object}
 */
export function updateShowStatus(data, id) {
  // チェックされたシリーズが1件未満にならないように制御
  if (data.filter(value => value.isShow).length <= 1 && !!data.find(value => value.isShow && value.id === id)) {
    return data
  }

  return data.map(value => {
    if (value.id === id) value.isShow = !value.isShow
    return value
  })
}

/**
 * 変動タイプを記号に変換する
 * @param {number} fluctuationType 変動タイプ
 */
export function toOperator(fluctuationType) {
  switch (fluctuationType) {
    case 1:
      return '＋'
    case 2:
      return '−'
    default:
      return '-'
  }
}

/**
 * チャートのラベルを省略形式に変換する
 * @param {string} label ラベル文字列
 * @param {number} unit 集計単位
 */
export function toShortLabel(label, unit) {
  switch (unit) {
    case 1:
      return +toTimeObject(label).hour
    case 2:
      return label.replace('日', '')
    case 3:
      return label.replace('曜日', '')
    case 4:
      return +label.split('/')[1]
    default:
      return label
  }
}

/**
 * チャートのannotationのstyleを取得する
 * @param {string[]} types 種別 point
 */
export function getAnnotationConfigs(...types) {
  const definitions = []
  const values = []

  if (types.includes('point')) {
    definitions.push({ type: 'string', role: 'style' })
    values.push('point { stroke-color: #fff; stroke-width: 1; }')
  }

  return { definitions, values }
}

/**
 * チャートの各pointに追加情報を付与する
 * @param {Array} dataTableArray チャートに渡すデータ
 * @param  {...any} annotations 各pointに付与するannotationのOption
 */
export function setAnnotations(dataTableArray, ...annotations) {
  return flatten(
    dataTableArray.map((data, index) => {
      // 先頭行(series名)なのでannotationを適用しない
      if (index === 0 || data === null) return data

      // applyIndexが該当する行にのみ適用
      return [data, ...annotations]
    }),
  )
}

/**
 * テーブルデータの組数上位 num 件のIDを降順にして返す
 * デフォルトは上位10件
 * @param {Array} value テーブルデータ
 * @param {Number} num 件数
 */
export function descendingOrder(value, num = 10) {
  // {sum: 合計値, id: ID} の形に抽出
  const sumObj = value?.map(arr => {
    return { sum: arr.sum.group.qty, id: arr.id }
  })
  // 降順にソート
  if (sumObj) sumObj.sort((current, next) => next.sum - current.sum)
  return sumObj?.slice(0, num).map(arr => arr.id)
}
